<template>
    <div>
        <el-form-item v-for="(item,index) in items"
                      v-if="item.data"
                      :label="item.name"
                      :rules="[{required:item.required,message:'required'}]"
                      :key="index">
            <el-input :disabled="disabled" v-if="item.type==='input' || item.type==='units' || item.type==='us'"
                      v-model="item.data"
                      :placeholder="item.placeholder"></el-input>
            <template v-else-if="item.type==='radio'">
                <label :style="i>0?'margin-left: 20px':''" v-for="(op,i) in item.options"
                       :key="op.label"
                       :label="op.label">
                    <input :disabled="disabled"
                           type="radio"
                           :checked="item.data===op.label? 'checked':''"></input>{{ op.label }}</label>
            </template>

            <el-date-picker :disabled="disabled" v-if="item.type==='date'" v-model="item.data"
                            format="dd MMM yyyy HH:mm:ss"
                            value-format="dd MMM yyyy HH:mm:ss" type="datetimerange"
                            :placeholder="item.placeholder"></el-date-picker>

            <div class="file-button" v-if="item.type==='upload'">
                <el-button @click="openWindows(item.data,true)" type="warning" plain><strong>Vehicle Log Card</strong>
                </el-button>
            </div>

        </el-form-item>
    </div>
</template>

<script>
import {openWindows} from "@/utils/WindowsUtils";

export default {
    name: "RegisterItem",
    props: {
        items: {},
        disabled: {}
    },
    methods: {
        openWindows: openWindows
    }
}
</script>

<style scoped>

</style>
